import { Dtos, SuretyAccountId, SuretyQuoteId } from "@inrev/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { accountQueryKey } from "../../account/account.keys";
import { adminActionItemsQueryKey } from "../../action-item/action-item.keys";
import { bondPreviewsQueryKey } from "../../bond/bond.keys";
import {
	bondRequestBondFormQueryKey,
	bondRequestIssuanceQueryKey,
	bondRequestLatestUnderwritingQueryKey,
	bondRequestsQueryKey,
} from "../bond-request.keys";
import { invalidateBondRequestIfClosed, redirectToIssuedBond } from "../utils";

export const useApproveBondFormForAgentIssue = (id: SuretyQuoteId, accountId: SuretyAccountId) => {
	const queryClient = useQueryClient();
	const { post } = useRequest();

	const mutation = useMutation({
		meta: { redirectOnError: redirectToIssuedBond },
		mutationKey: ["approveBondFormForAgentIssue", id],
		mutationFn: async (data: Dtos.Admin.SuretyBondForm.Approve.Request) => {
			await post(`/v2/admin/surety/accounts/${accountId}/quotes/${id}/bond-form/approve`, data);
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: bondRequestsQueryKey(id) });
			queryClient.invalidateQueries({ queryKey: bondRequestBondFormQueryKey(id) });
			queryClient.invalidateQueries({ queryKey: accountQueryKey(accountId) });
			queryClient.invalidateQueries({ queryKey: bondPreviewsQueryKey() });
			queryClient.invalidateQueries({ queryKey: bondRequestIssuanceQueryKey(id) });
			queryClient.invalidateQueries({
				queryKey: bondRequestLatestUnderwritingQueryKey(id),
			});
			queryClient.invalidateQueries({ queryKey: adminActionItemsQueryKey.all() });
		},
		onSettled: invalidateBondRequestIfClosed(queryClient, id),
	});

	return {
		approveBondFormForAgentIssue: mutation.mutate,
		approveBondFormForAgentIssueIsLoading: mutation.isPending,
	};
};
